import './CarPreview.scss';


import imagePlaceholder from '../../assets/images/cars/car-placeholder.png';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import {fetchCarModelsDump} from "../../services/api";
import carDetails from "../../pages/Progressive/CarDetails/CarDetails";

const CarPreview = ({
                        make,
                        model,
                        year,
                        car,
                        masterCarList,
                        modelOptions,
                        yearOptions,
                        trimOptions = [],
                        editModel,
                        openEdit,
                        cancelEdit,
                        carChanged,
                        showCarousel = false,
                        showEnlargedImage, setShowEnlargedImage
                    }) => {

    // let carImages = ["https://img.pmsrv.co/v1/media/1938A10A-8AA9-45A9-BA0B-729C12353514/ed78fc56-06de-4e27-85d9-010784ce0b0b",
    //     "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/1efe9907-1ecf-4437-acaa-85d33641f31c",
    //     "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/65fcf643-61e7-4399-85ec-db9ad20f8d99",
    //     "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/677fc9f2-c755-45bb-a10b-380b4459ff7e",
    //     "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/360da5ed-d626-4f8d-b693-f42d1278d8ac"]
    let imageUrls = []
    const location = useLocation();
    const params = new URLSearchParams(window.location.search);
    const customPrevArrow = (onClickHandler, hasPrev, label) => (
        <button
            type="button"
            className="custom-arrow custom-prev"
            onClick={onClickHandler}
            disabled={!hasPrev}
            aria-label={label}
        >
            <LeftOutlined/>
        </button>
    );

    const customNextArrow = (onClickHandler, hasNext, label) => (
        <button
            type="button"
            className="custom-arrow custom-next"
            onClick={onClickHandler}
            disabled={!hasNext}
            aria-label={label}
        >
            <RightOutlined/>
        </button>
    );

    if (masterCarList) {
        let carDetails = masterCarList.filter(_ => _.id === car.id)
        if (carDetails.length > 0)
            imageUrls = carDetails[0].imageUrls
    }

    function getImageShotId(imageUrl) {
        let splitUrl = imageUrl.split('_');
        let shotId = imageUrl
        if (splitUrl.length > 0)
            shotId = splitUrl[splitUrl.length - 1]
        return `shot_id_${shotId}`
    }

    const [tmpl, setTmpl] = useState('')
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        setTmpl(urlParams.get('tmpl'))
    }, [])

const hexCodeSelectionList =["0054A0", "005DB6", "007479", "008BD0", "0175CC", "025DAA", "052BE6", "084FA7", "085FA9", "12308F", "134A8D", "155AA5", "1C4781", "1F66D0", "2385CA", "264C44", "27371B", "285C78", "304D77", "314B2E", "354C32", "7299AA", "7E0D25", "7E1519", "811717", "81171D", "85081B", "85121A", "891120", "89320D", "91040B", "921820", "930013", "94121F", "953424", "97080C", "980017", "991C23", "9A080B", "9A1828", "9C2F34", "A10901", "A17250", "A3480D", "A5410F", "A60013", "A65929", "A81427", "A95925", "AB6427", "B06A20", "B1BB0D", "B2081D", "B2C945", "B30116", "B35026", "B79975", "B81B24", "B9481C", "BB8820", "BC3D3A", "C1A657", "C24221", "C3B643", "C8440C", "CF3801", "D01217", "D62933", "D88929", "D93C28", "D9BB44", "E66A1C", "E94B41", "EA6D22", "EBC51E", "EDB100", "F0601E", "F9DD56", "FD423D", "0C2E84", "4A4A4A", "3C4F70"];

const validHex = /[0-9A-Fa-f]{6}$/; 
const pickImageUrl =  (urls) => {
    for (const url of urls) {
        const parts = url.split('_');
        const lastPart = parts[parts.length - 1];
        if (validHex.test(lastPart) && hexCodeSelectionList.includes(lastPart)) {
            return url;
        }
    }

    const urlWithShortcode3 = urls.find(url => url.endsWith('_3'));
    if (urlWithShortcode3) {
        return urlWithShortcode3;
    }

    return urls[0];
}
const selectedImageUrl =  pickImageUrl(imageUrls) ;
const enlargeImage=()=>{

    if( (location.pathname==='/deals' || location.pathname==='/deal_ae')){
        setShowEnlargedImage(true);
    }

}
const getImageForT3 =  () => {
    return car?.image;
};

    return (<>
        <div className="car-image-name-container relative gcd-image-click">
            {
                // tmpl === 't1' ? <>
                //         <div className="car-image" style={{"paddingBottom":"0%",height:"auto"}}><img src={car && car?.image ? car?.image : imagePlaceholder}></img></div>
                //     </> :
                //     imageUrls.length > 1 ?
                //         window.location.pathname === '/deals_ae' ?
                //             <div className="car-image" style={{"paddingBottom":"0%",height:"auto"}}>
                //                 <img src={selectedImageUrl} alt='Get Auto Deals' />
                //             </div>
                //         :
                //             // Commenting Carousel part to remove Carousel from deals t2
                //             // <div className="carousel-parent-container">
                //             //     <Carousel autoPlay={false}
                //             //             renderArrowPrev={customPrevArrow}
                //             //             renderArrowNext={customNextArrow}
                //             //             showStatus={false}
                //             //             showArrows={true}
                //             //             thumbWidth={0}
                //             //             interval={1800}
                //             //             dynamicHeight={true}>
                //             //         {
                //             //             imageUrls.map((imageUrl) => {
                //             //                 return (
                //             //                     <div className="car-image overlay" key={imageUrl}
                //             //                         id={getImageShotId(imageUrl)}>
                //             //                         <img src={imageUrl}/>
                //             //                     </div>
                //             //                 )
                //             //             })
                //             //         }
                //             //
                //             //     </Carousel>
                //             // </div>
                //
                //             // added static image same as deals t1 for deals t2 after removing carousel
                //             <div className="car-image"  onClick={()=>enlargeImage()} style={tmpl==='t2'?{"paddingBottom":"0%",height:"auto","cursor":"pointer"}:{"paddingBottom":"0%",height:"auto"}}><img id="img-id"src={(car && car?.image) ?( tmpl!=='t3'? car?.image : getImageForT3()) :imagePlaceholder }></img></div>
                //         :
                //         <div className="car-image" onClick={()=>enlargeImage()} style={{"paddingBottom":"0%",height:"auto","cursor":"pointer"}}><img src={(car && car?.image) ?( tmpl!=='t3'? car?.image : (getImageForT3())) :imagePlaceholder }></img>
                //         </div>
                <div className="car-image"  style={(params.get('tmpl')==='t2' && window.innerWidth<760)?{"paddingBottom":"0%",height:"auto",marginBottom:"16px"}:{"paddingBottom":"0%",height:"auto"}}><img src={(car && car?.image) ?( getImageForT3()) :imagePlaceholder }  ></img>
                </div>

            }
        </div>
    </>)
}

export default CarPreview;